import axios from 'axios'
import { Message, MessageBox ,Loading} from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
let loading;

function startLoading() {
  loading = Loading.service({
    lock: true, //是否锁定
    text: '拼命加载中...', //加载中需要显示的文字
    background: 'rgba(0,0,0,.7)', //背景颜色
  });
}
//结束加载动画
function endLoading() {
  loading.close();
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // 请求超时时间
})
axios.defaults.withCredentials = true;
//暂时注掉
// // request拦截器
service.interceptors.request.use(config => {
  startLoading();//请求时的加载动画
  let token  = localStorage.getItem('token');
   if (token) {
       config.headers['Authorization'] = token  // 让每个请求携带自定义token 请根据实际情况自行修改
   }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
   endLoading()
  Promise.reject(error)
})

// // respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    endLoading();
    const res = response.data
    if (res.code == 401) {
      /*Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })*/
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
        location.reload()// 为了重新实例化vue-router对象 避免bug
       })
      })
      
      return Promise.reject('error')
    } else {
     
      return response
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
     endLoading()
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js